$(document).ready(function(){
  $(window).scroll(function(){
    //$(".site-header-wrapper").css("top","0");
  });


  if(sessionStorage.betaClosed !== "true"){

    var html = '<div id="productBetaInfo" class="small" style="text-align:left; font-size:12px; display:none;">'+
                                                '<a href="#" class="closeBt">X</a>'+
                '<p style="color:#fff">Orders placed on and after Friday 21st Dec will be fulfilled from 02nd Jan onwards.</p>'+
                                            '</div>'+
        '<div id="productBetaInfo" style="display:none;" class="big">'+
                                                '<a href="#" class="closeBt">X</a>'+
                                                '<p style="color:#fff">Orders placed on and after Friday 21st Dec will be fulfilled from 02nd Jan onwards. Customer Support will be available on 1300 764 276 except for 24th Dec and public holidays.</p>'+
                                            '</div>';
            $('#alphaflag').prepend(html);
            $("#alphaflag").show("fast",function(){
                $(".site-header-wrapper").css("top",$("#alphaflag").height()+"px");
            });
            $(window).resize(function(){
                if($("#alphaflag").is(":visible")){
                  $(".site-header-wrapper").css("top",$("#alphaflag").height()+"px");
                }else{
                  $(".site-header-wrapper").css("top","0");
                }
            });
            $('#productBetaInfo .closeBt').click(function(){
              $("#alphaflag").hide();
                $(this).parent("#productBetaInfo").remove();

                $(".site-header-wrapper").css("top","0");
                sessionStorage.betaClosed = true;
            });

            $(".feedbackLink").click(function(){

                if(screen.width > 1024){
                    var h = screen.height - 200;
                    var w = screen.width - 200;
                }
                popupCenter("https://www.surveymonkey.com/r/M3GBB6X", "MEA Feedback", w,h);
            });

        }
});
 function popupCenter(url, title, w, h) {
          // Fixes dual-screen position                         Most browsers      Firefox
          var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
          var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

          var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
          var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

          var left = ((width / 2) - (w / 2)) + dualScreenLeft;
          var top = ((height / 2) - (h / 2)) + dualScreenTop;
          var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

          // Puts focus on the newWindow
          if (window.focus) {
              newWindow.focus();
          }
      }
